import { ProjectCustomerWhatsAppItemDTO } from '../../domain/project/ProjectDTO';
import { ProjectCustomerWhatsAppItem } from '../../domain/project/projectCustomerWhatsApp/ProjectCustomerWhatsAppItem';

export class ProjectCustomerWhatsAppItemMapper {
  static toDomain(props: ProjectCustomerWhatsAppItemDTO): ProjectCustomerWhatsAppItem {
    const { subaccount_id, from, enabled, template_id, replacement_values, updated_at } = props;

    return ProjectCustomerWhatsAppItem.create({
      subaccount_id,
      from,
      enabled,
      template_id,
      replacement_values,
      updated_at,
    });
  }

  static toRepository(WhatsAppMessage: ProjectCustomerWhatsAppItem): ProjectCustomerWhatsAppItemDTO {
    return {
      subaccount_id: WhatsAppMessage.subaccount_id,
      from: WhatsAppMessage.from,
      enabled: WhatsAppMessage.enabled,
      template_id: WhatsAppMessage.template_id,
      replacement_values: WhatsAppMessage.replacement_values,
      updated_at: WhatsAppMessage.updated_at,
    };
  }
}
